// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"legal_legalContainer__Q64uM","legalLinksContainer":"legal_legalLinksContainer__MI0Gb","legalLink":"legal_legalLink__BwlUc","copyright":"legal_copyright__3uTe2"};